<template>
    <div class="video-play-container" :style="videoStyle" v-loading="loading">
      <div v-if="url" :id="videoId" class="video-play-container" :style="videoStyle"></div>
      <div v-else class="video-play-container-error">暂无视频</div>
    </div>
  </template>
  <script>
  import EZUIKit from "ezuikit-js";
  
  import { getDeviceLiveAddressTokenApi } from "@/api/lsyn2";
  
  export default {
    name: "",
    props: {
      url: {
        // 视频地址
        type: [String,Object],
        required: true
      },
      token: {
        // 视频token
        type: String,
        required: true
      },
      videoId: {
        // 视频容器ID
        type: String,
        default: "video-container"
      },
      videoWidth: {
        // 视频宽度
        type: Number,
        default: 600
      },
      videoHeight: {
        // 视频高度
        type: Number,
        default: 400
      },
      flushToken: {
        // 每次请求是否刷新token
        type: Boolean,
        default: false
      },
      template: {
        type: String,
        default: "pcLive"
      }
    },
    data() {
      return {
        player: null,
        accessToken:
          "at.6frwrqrt578mq751d2tv5acscw9g7mid-7eg85uucea-0qowtjc-vzyiwueps",
        loading: false
      };
    },
    computed: {
      videoStyle() {
        return {
          width: this.videoWidth + "px",
          height: this.videoHeight + "px"
        };
      }
    },
    watch: {
      url(newValue) {
        console.log("url", newValue);
        // this.option.sources[0].src = newValue
        if (newValue) {
          if (this.player) {
            if (this.flushToken) {
              this.refreshPlayer();
            } else {
              this.replayPlayer();
            }
          } else {
            this.initPlayer();
          }
        } else {
          if (this.player) {
            this.destroyPlayer();
          }
        }
      }
    },
    created() {
      console.log("videoPlay", this.url, this.token);
    },
    mounted() {
      this.initPlayer();
    },
    async beforeMount() {
      console.log("videoPlay beforeMount", this.url, this.token);
      this.destroyPlayer();
    },
    methods: {
      async initPlayer() {
        console.log("player initPlayer", this.url);
        if (this.url) {
          this.loading = true;
          const { url, videoId, videoWidth, videoHeight, template } = this;
          this.accessToken = await this.getYSYToken();
          var player = new EZUIKit.EZUIKitPlayer({
            id: videoId, // 视频容器ID
            accessToken: this.accessToken,
            url,
            template,
            width: videoWidth, // 播放器宽度
            height: videoHeight, // 播放器高度
            handleSuccess: player => {
              this.loading = false;
              console.log("handleSuccess", player);
            },
            handleError: error => {
              this.loading = false;
              console.log("handleError", error);
              this.msgError(
                error.message || error.msg || "播放失败，请稍后重试！"
              );
            }
          });
          console.log("player", player);
          this.player = player;
        }
      },
      async replayPlayer() {
        console.log("player replayPlayer", this.url);
        // 切换播放地址场景（注意先执行stop方法停止上次取流）
        if (!this.player) {
          return;
        }
        this.loading = true;
        try {
          await this.player.stop();
          await this.player.play({
            url: this.url
          });
        } catch (e) {
          console.log("player replayPlayer error", e);
          this.msgError(e.message || e.msg || "播放失败，请稍后重试！");
        } finally {
          this.loading = false;
        }
      },
      async refreshPlayer() {
        if (!this.player) {
          return;
        }
        this.loading = true;
        try {
          await this.player.stop();
          this.accessToken = await this.getYSYToken();
          await this.player.play({
            url: this.url,
            accessToken: this.accessToken
          });
        } catch (e) {
          console.log("player replayPlayer error", e);
          this.msgError(e.message || e.msg || "播放失败，请稍后重试！");
        } finally {
          this.loading = false;
        }
      },
      getYSYToken() {
        return new Promise((resolve, reject) => {
          getDeviceLiveAddressTokenApi()
            .then(res => {
              if (res.code == 200) {
                resolve(res.data);
              } else {
                reject(res.msg);
              }
            })
            .catch(err => {
              reject(err);
            });
        });
      },
      stopPlayer() {
        this.player && this.player.stop();
      },
      async destroyPlayer() {
        if (this.player) {
          try {
            await this.player.stop();
            await this.player.destroy();
          } finally {
            this.player = null;
            console.log("videoPlay beforeMount end");
          }
        }
      }
    }
  };
  </script>
  <style lang="less">
  .video-play-container {
    width: 100%;
    height: 100%;
    background: white;
  }
  
  .video-play-container-error {
    width: 100%;
    height: 100%;
    color: red;
    align-items: center;
    justify-content: center;
    display: flex;
    font-size: 16px;
  }
  </style>
  